import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdTableRow = _resolveComponent("AdTableRow")!

  return (_openBlock(), _createElementBlock("table", {
    style: _normalizeStyle({ width: _ctx.tableWidth ? _ctx.tableWidth + 'px' : '100%' })
  }, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
          return (_openBlock(), _createElementBlock("td", {
            style: _normalizeStyle({ width: column.width ? column.width + 'px' : 'initial' }),
            key: column.key,
            class: _normalizeClass({ asc: column.key === _ctx.sortBy, desc: column.key + ' desc' === _ctx.sortBy, sortable: column.isSortable }),
            onClick: ($event: any) => (_ctx.filter(column))
          }, [
            _createElementVNode("span", {
              innerHTML: column.title
            }, null, 8, _hoisted_2)
          ], 14, _hoisted_1))
        }), 128))
      ])
    ]),
    (!_ctx.onlyHeader)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
            return (_openBlock(), _createBlock(_component_AdTableRow, {
              key: item.adId,
              ad: item,
              columns: _ctx.columns,
              onSelected: _ctx.onSelected,
              onHover: _ctx.onHover,
              class: _normalizeClass({ selected: _ctx.selected && _ctx.selected.adId === item.adId })
            }, null, 8, ["ad", "columns", "onSelected", "onHover", "class"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 4))
}